import React from "react";
import { formatDate } from "common/formatters";

export interface LastUpdatedProps {
    lastUpdated: Date;
    label?: string;
}


const LastUpdated: React.FC<LastUpdatedProps> = (props: LastUpdatedProps) => {
    const updatedTime = formatDate(props.lastUpdated, 'MM/DD/YY hh:mm A');

    return <span className="text-muted">
        {props.lastUpdated && <small>
            {props.label ?? "Updated"} <span className="hover-text" title={updatedTime}> {updatedTime}</span>
        </small>}
    </span>
}

export default LastUpdated;